var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.dialog_show)?_c('Dialog',{attrs:{"title":"绑定Steam"},on:{"close":_vm.close}},[_c('p',[_vm._v("请复制如下命令并发送到游戏内聊天框完成绑定:")]),_c('p',[_vm._v("!bind "+_vm._s(_vm.userId))]),_c('p',[_vm._v("发送后请刷新页面查看是否绑定成功(会显示Steam头像和名称)")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }